import React from 'react';
import { Button } from 'reactstrap';
import { IconHeart } from '@tabler/icons-react';
import { IInvestorFavorite } from '../models/dashboardModels';
import { getNamedFavorites } from '../adapters/favoritesAdapter';

interface FavoritesViewButtonProps {
  favorites: IInvestorFavorite[] | undefined;
  onClick: () => void;
}

const FavoritesViewButton: React.FC<FavoritesViewButtonProps> = ({
  favorites,
  onClick,
}) => {
  if (getNamedFavorites(favorites).length === 0) return null;

  return (
    <div className="mt-2">
      <Button size="sm" color="outline-primary" onClick={onClick}>
        <IconHeart size={14} className="me-1" />
        Ver favoritos
      </Button>
    </div>
  );
};

export default FavoritesViewButton;
